<template>
  <div>
    <v-dialog v-model="show" width="500px">
      <v-card class="pa-5">
        <h4 style="text-align: center">PROJECT DESCRIPTION</h4>
        <label>Language</label>
        <v-autocomplete
          label="choose language"
          outlined
          v-model="detail.language"
          :items="languages"
          item-text="language_name"
          item-value="id"
        >
        </v-autocomplete>
        <label>Description</label>
        <vue-editor
          v-model="detail.description"
          :editorToolbar="customToolbar"
        ></vue-editor>
        <v-card-actions>
          <v-btn rounded color="primary" @click="addDescription">Add</v-btn>
          <v-btn rounded color="secondary" @click="clearDescription"
            >Cancel</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import {VueEditor} from "vue2-editor";
import DEFAULT_CONSTANTS from "@/Utilites/constants";

export default {
  name: "ProjectDescriptionAdd",
  components: {
    "vue-editor": VueEditor,
  },
  props: ["languages", "addDetail"],
  data() {
    return {
      detail: {
        language: "",
        description: "",
      },
      customToolbar: [
        ["bold", "italic", "underline"],
        [{list: "ordered"}, {list: "bullet"}],
        ["link", "code-block"],
      ],
    };
  },
  computed: {
    show: {
      get() {
        return this.addDetail;
      },
      set(show) {
        this.$emit("add-description-model-update", show);
      },
    },
  },
  methods: {
    ...mapActions([
      "CreateProjectTranslation",
      "showLoadingProcess",
      "closeLoading",
      "showSnackBar",
      "closeSnackBar",
    ]),
    async addDescription() {
      await this.showLoadingProcess();
      try {
        const data = {
          project_id: this.$route.query.project_id,
          language_id: this.detail.language,
          project_detail_description: this.detail.description,
        };
        await this.CreateProjectTranslation(data);
        await this.closeLoading();
        await this.showSnackBar({
          text: "Description has be added to Project",
          color: DEFAULT_CONSTANTS.success,
        });
        this.clearDescription();
        setTimeout(async () => {
          await this.closeSnackBar();
        }, DEFAULT_CONSTANTS.timeout);
      } catch (err) {
        await this.closeLoading();
        console.log(err);
        await this.showSnackBar({
          text: "Insert Failed",
          color: DEFAULT_CONSTANTS.error,
        });
        this.clearDescription();
        setTimeout(async () => {
          await this.closeSnackBar();
        }, DEFAULT_CONSTANTS.timeout);
      }
    },
    clearDescription() {
      this.detail = {};
      this.show = false;
    },
  },
};
</script>

<style scoped></style>
